<div>
  <mat-card>
    <form [formGroup]="MapIncomeToBusinessSegmentForm">
      <mat-card-content>
        <mat-form-field appearance="fill">
          <mat-label>Select Business Segment</mat-label>
          <mat-select formControlName="segmentId" required>
            <mat-option>
              <ngx-mat-select-search [searching]="searching" [formControl]="segmentSearchCtrl"
                noEntriesFoundLabel="'no matching segments found'"
                placeholderLabel="Search Business Segment">
                <mat-icon ngxMatSelectSearchClear>close</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            @for (s of filteredSegments | async; track s) {
              <mat-option [value]="s.id">
                {{s.businessSegmentName}} ({{s.businessSegmentCode}})
              </mat-option>
            }
          </mat-select>
          @if (segmentId.touched && segmentId.invalid && segmentId.hasError('required')) {
            <mat-error>Segment
            is required</mat-error>
          }
        </mat-form-field>

      </mat-card-content>

      <div class="mat-elevation-z8">
        <table mat-table [dataSource]="chargeDetailsDataSource" formArrayName="chargeDetails"
          class="full-width-table">

          <!-- Charge Code -->
          <ng-container matColumnDef="chargeCode">
            <th mat-header-cell *matHeaderCellDef>Charge Code</th>
            <td mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
              <mat-form-field appearance="fill">
                <mat-label>Select Charge Code</mat-label>
                <mat-select formControlName="chargeId" (selectionChange)="chargedChanged(i)" required>

                  <mat-option>
                    <ngx-mat-select-search [searching]="searching"
                      [formControl]="chargeCodeSearchCtrl" placeholderLabel="Search Charge Code"
                      noEntriesFoundLabel="No item found">
                      <mat-icon ngxSelectSearchClear>delete</mat-icon>
                    </ngx-mat-select-search>
                  </mat-option>

                  @for (c of filteredCharges; track c) {
                    <mat-option [value]="c.parentId"
                      [disabled]="checkChargeDisableCondition(c)">
                      {{c.code}} ({{c.name}})
                    </mat-option>
                  }

                </mat-select>
                @if (chargeDetails.at(i).get('chargeId')?.hasError('required')) {
                  <mat-error>
                    Charge Code is Required
                  </mat-error>
                }
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Charge Name -->
          <ng-container matColumnDef="chargeName">
            <th mat-header-cell *matHeaderCellDef>Charge Name</th>
            <td mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
              <mat-form-field appearance="fill">
                <input matInput formControlName="chargeName" autocomplete="off" readonly>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Charge Category -->
          <ng-container matColumnDef="chargeCategory">
            <th mat-header-cell *matHeaderCellDef>Charge Category</th>
            <td mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
              <mat-form-field appearance="fill">
                <input matInput formControlName="chargeCategory" autocomplete="off" readonly>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Unit Type -->
          <!-- <ng-container matColumnDef="unitType">
          <th mat-header-cell *matHeaderCellDef>Unit Type</th>
          <td mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
            <mat-form-field appearance="fill">
              <input matInput formControlName="unitType" autocomplete="off" readonly>
            </mat-form-field>
          </td>
        </ng-container> -->


        <!-- Columns to add in future -->
        <!--    <ng-container matColumnDef="sacCode">
        <th mat-header-cell *matHeaderCellDef>SAC Code</th>
        <td mat-cell *matCellDef="let row">
          <input matInput [(ngModel)]="row.sacCode">
        </td>
      </ng-container>

      <ng-container matColumnDef="sacName">
        <th mat-header-cell *matHeaderCellDef>SAC Name</th>
        <td mat-cell *matCellDef="let row">
          <input matInput [(ngModel)]="row.sacName">
        </td>
      </ng-container>

      <ng-container matColumnDef="sGST">
        <th mat-header-cell *matHeaderCellDef>SGST</th>
        <td mat-cell *matCellDef="let row">
          <input matInput type="number" [(ngModel)]="row.sgst">
        </td>
      </ng-container>

      <ng-container matColumnDef="cGST">
        <th mat-header-cell *matHeaderCellDef>CGST</th>
        <td mat-cell *matCellDef="let row">
          <input matInput type="number" [(ngModel)]="row.cgst">
        </td>
      </ng-container>

      <ng-container matColumnDef="iGST">
        <th mat-header-cell *matHeaderCellDef>IGST</th>
        <td mat-cell *matCellDef="let row">
          <input matInput type="number" [(ngModel)]="row.igst">
        </td>
      </ng-container>

      <ng-container matColumnDef="gstFrom">
        <th mat-header-cell *matHeaderCellDef>GST Valid From</th>
        <td mat-cell *matCellDef="let row">
          <input matInput type="date" [(ngModel)]="row.gstWef">
        </td>
      </ng-container>

      <ng-container matColumnDef="gstUpto">
        <th mat-header-cell *matHeaderCellDef>GST Valid Upto</th>
        <td mat-cell *matCellDef="let row">
          <input matInput type="date" [(ngModel)]="row.gstWef">
        </td>
      </ng-container>

      <ng-container matColumnDef="centralCess">
        <th mat-header-cell *matHeaderCellDef>Central Cess</th>
        <td mat-cell *matCellDef="let row">
          <input matInput type="date" [(ngModel)]="row.gstWef">
        </td>
      </ng-container>

      <ng-container matColumnDef="stateCess">
        <th mat-header-cell *matHeaderCellDef>State Cess</th>
        <td mat-cell *matCellDef="let row">
          <input matInput type="date" [(ngModel)]="row.gstWef">
        </td>
      </ng-container>

      <ng-container matColumnDef="deactivate">
        <th mat-header-cell *matHeaderCellDef>Deactivate Charge</th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox [(ngModel)]="row.deactivated"></mat-checkbox>
        </td>
      </ng-container>  -->

      <!-- ACTION -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let row; let i = index">

          <!-- Add Row -->
          <button mat-icon-button color="primary" (click)="addRow()">
            <mat-icon>add</mat-icon>
          </button>

          <!-- Delete Row -->
          <button mat-icon-button color="warn" (click)="deleteRow(i)"
            [disabled]="chargeDetailsDataSource.data.length === 1">
            <mat-icon>delete</mat-icon>
          </button>

        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
  </div>

  <mat-card-actions>
    <button mat-button color="primary"
      [disabled]="(!editPermission && this.id.value) || (!addPermission && !this.id.value)"
    (click)="onSave()">Save</button>
    <!-- <button mat-button color="primary" (click)="onSave()">Save</button> -->
    <button mat-button color="cancel" (click)="onCancel()">Cancel</button>
    <!-- <button mat-button color="revert" (click)="onRevert()">Revert</button> -->
  </mat-card-actions>

</form>
</mat-card>
</div>